// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "d9f88168d333bb85","396": "12281ff800a2064b","460": "1e496224cf942918","498": "549bc70eabe4a99a","917": "00833124c07a1eb4","985": "15f4240d09e414bd",}[chunkId] + ".chunk.js"
}